import { Injectable } from '@angular/core';

import { ApiBaseService } from "../../common/providers/api-base-service";
import { Observable } from 'rxjs';
import { FeedbackAthleteQuestionAnswer } from "../../common/models/feedback-athlete-question-answer";
import { Organization } from "../../common/models/organization";
import { Feedback } from "../../common/models/feedback";
import { Athlete } from "../../common/models/athlete";
import { Timeslot } from "../../common/models/timeslot";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class AthleteQuestionAnswerProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser
    ) {}

    /**
     * Find all Question for a Feedback
     */
    public save(organization: Organization, feedback: Feedback, athlete: Athlete, answers: FeedbackAthleteQuestionAnswer[], timeslot: Timeslot | null = null): Observable<void> {
        return this.api.call('post',`organizations/${organization.code}/feedback/${feedback.id}/athlete/${athlete.userId}/save`, {
            answers,
            timeslot: timeslot ? timeslot.id : null
        },
          this.currentUser.getAccessToken()
        );
    }
}

export class FeedbackQuestionSurvey {
    public id;
    public type;
    public title;
    public help;
    public sortOrder;

    constructor(id: any, type: any, title: any, help: any, sortOrder: any) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.help = help;
        this.sortOrder = sortOrder;
    }
}
